// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1Ph6t","modalForm":"UpgradeEpcsModal_modalForm__25ilk","modalFooter":"UpgradeEpcsModal_modalFooter__19_Qh"};